import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=9da4cf3a&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da4cf3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9da4cf3a')) {
      api.createRecord('9da4cf3a', component.options)
    } else {
      api.reload('9da4cf3a', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=9da4cf3a&scoped=true&", function () {
      api.rerender('9da4cf3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/utube/Index.vue"
export default component.exports